module.exports = __webpack_public_path__ + "img/BrokerLicense.10be5ce3.jpg";